import { Button, ClearableInput, Select } from "@rio-cloud/rio-uikit";
import DatePicker from "@rio-cloud/rio-uikit/DatePicker";
import moment from "moment";

import AppointmentCard from "../../../../../../components/appointmentCard";
import AppointmentCardSkeleton from "../../../../../../components/appointmentCard/appointmentCardSkeleton";

import useSchedulingList from "../../../../../../hooks/useSchedulingList";

import "../styles.scss";
import { useMediaQuery } from "@mui/material";

const Appointments = (props: any) => {
  const {
    schedulings,
    getSchedulings,
    sortDirection,
    setSortDirection,
    searchByChassis,
    date,
    setDate,
    datePickerKey,
    clearDateFilter,
    status,
    setStatus,
    loading,
    hasMoreData,
  } = useSchedulingList("dealership");

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <>
      <div className={`flex gap-6 margin-top-15 search-filter ${isMobile ? "flex-wrap" : ""}`}>
        <div className={`form-group search-group ${isMobile ? "!w-full !mb-0" : ""}`}>
          <div className="input-group">
            <span className="input-group-addon">
              <span className="rioglyph rioglyph-search" aria-hidden="true" />
            </span>
            <ClearableInput
              id="search-button"
              placeholder="Busque por chassi"
              onChange={(value: string) => searchByChassis(value)}
            />
          </div>
        </div>

        <div className={`form-group search-group relative ${isMobile ? "!w-full !mb-0" : ""}`}>
          <DatePicker
            key={datePickerKey}
            id="date-picker"
            inputProps={{ placeholder: "Escolha a data" }}
            dateFormat="DD-MM-YYYY"
            timeFormat={false}
            locale="pt-br"
            onChange={(value) =>
              moment.isMoment(value) ? setDate(value) : setDate(null)
            }
            value={date ?? undefined}
          />

          {date && (
            <span
              className="rioglyph rioglyph-remove-sign absolute right-10 top-10 cursor-pointer text-color-gray"
              onClick={clearDateFilter}
            />
          )}
        </div>

        <div className={`form-group select-group ${isMobile ? "!w-full !mb-0" : ""}`}>
          <Select
            id="sort-type"
            options={[
              { id: "asc", label: <span>Crescente</span>, selected: true },
              { id: "desc", label: <span>Decrescente</span>, selected: false },
            ]}
            value={[sortDirection]}
            onChange={(selected) => setSortDirection(selected?.id ?? "asc")}
          />
        </div>

        <div className={`form-group select-group ${isMobile ? "!w-full !mb-0" : ""}`}>
          <Select
            id="status-filter"
            options={[
              { id: "", label: <span>Todos</span>, selected: status === "" },
              { id: "AC", label: <span>Agendados</span>, selected: status === "AC" },
              { id: "C", label: <span>Cancelados</span>, selected: status === "C" },
              { id: "F", label: <span>Finalizados</span>, selected: status === "F" },
            ]}
            value={[status]}
            onChange={(selected) => setStatus(selected?.id ?? "")}
          />
        </div>
      </div>

      {!loading && schedulings && schedulings.length === 0 ? (
        <div className="flex justify-center padding-top-10">
          <span className="text-color-gray">
            Não existem agendamentos realizados.
          </span>
        </div>
      ) : null}

      {schedulings &&
        schedulings.map((appointment) => (
          <AppointmentCard schedule={appointment} userType="dealership" />
        ))}

      {loading
        ? Array.from({ length: 10 }).map((_, index) => (
            <AppointmentCardSkeleton id={index.toString()} />
          ))
        : null}

      {hasMoreData && !loading ? (
        <div className="flex justify-center padding-top-20">
          <Button
            bsStyle={Button.PRIMARY}
            variant={Button.VARIANT_LINK}
            iconName="rioglyph-arrow-down"
            onClick={() => getSchedulings()}
          >
            Carregar mais
          </Button>
        </div>
      ) : null}
    </>
  );
};

export default Appointments;
